import script from "./BaseSearchbar.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSearchbar.vue?vue&type=script&setup=true&lang=js"

import "./BaseSearchbar.vue?vue&type=style&index=0&id=6a325753&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a325753"]])

export default __exports__